 <div class='facet-list'>
     <div *ngFor='let facet of facets; let i = index;'>
         <div class="facet-list-item" *ngIf='facet.valid && facet.value && facet.value.length > 0'>
            <div class="section pointMe" 
           		(click)="toggleExpand(i)" 
           		[ngClass]="{'includess-criteria' : (facetCriteria.indexOf(facet.name) !== -1 || facetCriteria.indexOf(facet.solrfieldname) !== -1 )}">
                 <h5 class="panel-heading" style="margin:0;"
                     [ngClass]='{"closed" : !expandedStates[i] , "open" : expandedStates[i]}'>
                     {{facet.displayName}}
                     <span class="glyphicon pull-right"
                           [ngClass]='{"glyphicon-chevron-down" : expandedStates[i] , "glyphicon-chevron-up" : !expandedStates[i]}'>
             		</span>
                 </h5>           		
            </div> 
           
            <!-- Expanded section --> 
             <div class="well" *ngIf="expandedStates[i]">
                 <div class="facet-panel facet-container">
                     <div>
			            <div class="facetfilter-container">
			                <div class="facetfilter-icon fas fa-search"></div>
			                <input id="facet-filter" name="facet-filter" class="facetfilter-input"
			                       [(ngModel)]="facetfilter[facet.name]"
			                       (focus)="focused[facet.name] = true"
			                       (blur)="focused[facet.name] = false" />
			                <div class="facetfilter-placeholder" 
			                     [class.hidden]="focused[facet.name] === true"
			                     [hidden]="facetfilter[facet.name].length > 0">
			                    {{ LOCALIZATION.filter }}
			                </div>
			            </div>                         
                     </div>
                    <ng-container *ngFor="let facetItem of (facet.value | facetHideFilter | facetRefineFilter:facetfilter[facet.name] | slice:0:facetLimit[facet.name])">
						<div class="facet-option" [hidden]="facetItem.hide">
						  <input 
						  	*ngIf="facet.multiFaceted"
						  	type="checkbox" 
						  	[(ngModel)]="facetItem.checked" 
						  	(change)="toggleFacet(facet, facetItem)" 
						  	class="facet-checkbox" 
						  />
						  <a 
						  	*ngIf="facet.multiFaceted"
						  	(click)="facetItem.checked = true; triggerFacet(facet, facetItem, true);" 
						     class="truncate-link pointMe"
						     style="padding-left:4px;" 
						     [title]="facetItem.displayName">
						    {{ facetItem.displayName }}
						  </a>
						  <a 
						  	*ngIf="!facet.multiFaceted"
						  	(click)="triggerFacet(facet, facetItem, false);" 
						     class="truncate-link pointMe"
						     style="padding-left:4px;" 
						     [title]="facetItem.displayName">
						    {{ facetItem.displayName }}
						  </a>					  
						  <span class="facet-count" style="vertical-align: top;">{{ facetItem.count }}</span>
						</div> 
					</ng-container>                    
                 </div>
                 <div class="facet-more-facets">
                     <button 
                     	class="btn btn-xs btn-default" 
                     	*ngIf="facetLimit[facet.name] < facetVisibleCount[facet.name]"
                        (click)="facetLimit[facet.name] = facetVisibleCount[facet.name]">
                        	{{LOCALIZATION.more}}
                     </button>
                 </div>
                 <div class="facet-more-facets">
                     <button 
                     	class="btn btn-xs btn-default" 
                     	*ngIf="facet.value.filter(filterByHidden).length > maxLimit && facetLimit[facet.name] == maxLimit"
                        (click)="showAll(facet)">
                        	{{LOCALIZATION.showAll}}
                     </button>
                 </div> 
             </div>
         </div>
     </div>
 </div>
 <div *ngIf="!facets || facets.length == 0"> <i>{{LOCALIZATION.facetsEmpty}}</i></div>
 